import React, { useState, useEffect } from "react";
import injectSheet from "react-jss";
import { Forwardbutton } from "../../components/Buttons";
import EditTextAreaElement from "../../components/edit-element/EditTextAreaElement";
import EditTextElement from "../../components/edit-element/EditTextElement";
import GustavModal from "../../components/GustavModal/GustavModal";
import axios from "axios";
import { getDeviceInfo } from "../../utils/helpers";

const ContactModal = ({ classes }) => {
  const [showModal, setShowModal] = useState(false);
  const [formErrors, setFormErrors] = useState({});
  const [hasSent, setHasSent] = useState(false);
  const [formData, setFormData] = useState({
    firstName: "",
    lastName: "",
    epost: "",
    message: "",
    email: "",
    technicalInfo: "",
  });

  useEffect(() => {
    setFormData({ ...formData, technicalInfo: getDeviceInfo() });
  }, []);

  const validateFormData = () => {
    if (
      formData.firstName === "" ||
      formData.lastName === "" ||
      formData.message === "" ||
      formData.email === ""
    ) {
      setFormErrors({
        firstName: formData.firstName === "" ? "Vänligen fyll in förnamn" : "",
        lastName: formData.lastName === "" ? "Vänligen fyll in efternamn" : "",
        message: formData.message === "" ? "Vänligen beskriv ärendet" : "",
        email: formData.email === "" ? "Vänligen fyll in e-postadress" : "",
      });
      return false;
    } else {
      return true;
    }
  };

  const onChangeField = (field) => (event) => {
    setFormData({
      ...formData,
      [field]: event.target.value,
    });
  };

  const onSend = async () => {
    if (validateFormData()) {
      let res = await postData("/api/support/ticket", { ...formData });
      if (res) {
        setHasSent(true);
      }
    }
  };

  const postData = async (url, data) => {
    try {
      if (data) {
        var bodyFormData = new FormData();
        bodyFormData.append("data", JSON.stringify(data));
        const options = {
          method: "POST",
          data: bodyFormData,
          url: url,
        };
        return (
          await axios(options).catch((error) => {
            console.error(
              "error from url:" + url,
              error.response ? error.response.status : error
            );
            return false;
          })
        ).data;
      }
    } catch (err) {
      return false;
    }
  };

  return (
    <>
      {showModal && (
        <GustavModal
          dontCloseOnClickOutside
          onCloseRequest={() => setShowModal(false)}
        >
          <div className={classes.modalContainer}>
            <div className={classes.modalTitle}>Kontakta Teknisk support</div>
            {!hasSent ? (
              <>
                <div className={classes.modalDescription}>
                  För att vi lättare ska kunna hjälpa dig, ber vi dig fylla i
                  formuläret nedan.
                </div>
                <div className={classes.modalRow}>
                  <EditTextElement
                    id="firstName"
                    label="Förnamn"
                    required
                    value={formData.firstName}
                    handleEventChange={onChangeField("firstName")}
                    cy_id="firstName-input"
                    error={formErrors.firstName}
                  />
                  <EditTextElement
                    id="lastName"
                    label="Efternamn"
                    required
                    value={formData.lastName}
                    handleEventChange={onChangeField("lastName")}
                    cy_id="lastName-input"
                    error={formErrors.lastName}
                  />
                </div>
                <EditTextElement
                  id="email"
                  label="E-postadress"
                  required
                  value={formData.email}
                  handleEventChange={onChangeField("email")}
                  cy_id="email-input"
                  error={formErrors.email}
                />
                <EditTextAreaElement
                  id="message"
                  label="Beskrivning av ärendet"
                  required
                  value={formData.message}
                  handleEventChange={onChangeField("message")}
                  cy_id="message-input"
                  error={formErrors.message}
                />
                <div className={classes.modalSendButton}>
                  <Forwardbutton onClick={onSend}>Skicka</Forwardbutton>
                </div>
              </>
            ) : (
              <div className={classes.modalConfirmation}>
                Vi har mottagit ditt supportärende, vi kommer kontakta dig på
                angiven mejladress {formData.email}
              </div>
            )}
          </div>
        </GustavModal>
      )}
      <span className={classes.container} onClick={() => setShowModal(true)}>
        teknisk support
      </span>.
    </>
  );
};

const styles = {
  container: {
    textDecoration: "underline",
    color: "#335cda",
    cursor: "pointer",
  },
  modalContainer: {
    maxWidth: "380px",
    margin: "0 auto",
    color: "#353c43",
  },
  modalTitle: {
    fontSize: 22,
    fontWeight: 500,
    marginBottom: "15px",
  },
  modalDescription: {
    marginBottom: "30px",
    textAlign: "left",
  },
  modalRow: {
    display: "flex",
    justifyContent: "space-between",
  },
  modalSendButton: {
    display: "flex",
    justifyContent: "flex-end",
  },
  modalConfirmation: {
    textAlign: "left",
  },
};
export default injectSheet(styles)(ContactModal);
